import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO56 = () => {

  return (
    <StaticImage
      src="../../images/JPG-MALE-LOOK005-6.jpg"
      
      alt="Reserved avatar"
    />
  )
}

export default ImageMO56
